export default __webpack_public_path__ + "static/bg-cta--right-37953a6a1664b8b54fda050101f3afca.svg";